import { createStore, type Store } from 'effector'
import { type IAuthorizeErrors } from '../../index.h'

// TODO not the best way to store errors imho. - (4 derived stores and 1 normal) -
// could be just (4 normal stores)
export const $authorizeErrors = createStore<IAuthorizeErrors>({})

export const $creditCardNumberError: Store<string> = $authorizeErrors.map(
  (errors) => errors.cardNumber ?? ''
)

export const $creditCardExpirationTimeError: Store<string> =
  $authorizeErrors.map((errors) => errors.expirationDate ?? '')

export const $creditCardCvvError: Store<string> = $authorizeErrors.map(
  (errors) => errors.cvv ?? ''
)

export const $commonAuthorizeError: Store<string> = $authorizeErrors.map(
  (errors) => errors.commonError ?? ''
)
